import { Skeleton } from '@townsquare/griffin-main-header/skeleton';
import Loadable from '@townsquare/loadable';
import { aggProjectRoute } from '@townsquare/routes/agg-project-view';

import { aggProjectViewResource } from './resources/ProjectViewResourceAgg';
import { aggProjectViewTabResource } from './resources/ProjectViewTabResourceAgg';

aggProjectRoute.component = Loadable({
	loader: () => import(/* webpackChunkName: "agg-project-view" */ './components/ProjectViewAgg'),
	loading: Skeleton,
});
aggProjectRoute.nav4Layout = 'custom';
aggProjectRoute.relayEnvironment = 'agg';
aggProjectRoute.resources = [aggProjectViewResource, aggProjectViewTabResource];

export const aggProjectViewRoute: typeof aggProjectRoute = aggProjectRoute;
